function fixtureTimestamp(fixture) {
  const timestamp = new Date(fixture?.starting_at).getTime();
  return Number.isFinite(timestamp) ? timestamp : Number.POSITIVE_INFINITY;
}

function numericFixtureId(fixture) {
  const id = Number(fixture?.id ?? fixture?.fixture_id);
  return Number.isFinite(id) ? id : Number.POSITIVE_INFINITY;
}

export function compareFixturesCanonical(left, right) {
  const leftTimestamp = fixtureTimestamp(left);
  const rightTimestamp = fixtureTimestamp(right);
  if (leftTimestamp !== rightTimestamp) {
    return leftTimestamp < rightTimestamp ? -1 : 1;
  }

  const leftId = numericFixtureId(left);
  const rightId = numericFixtureId(right);
  if (leftId !== rightId) {
    return leftId < rightId ? -1 : 1;
  }

  return String(left?.id ?? left?.fixture_id ?? "").localeCompare(
    String(right?.id ?? right?.fixture_id ?? ""),
    undefined,
    { numeric: true },
  );
}

export function sortFixturesCanonical(fixtures = []) {
  return [...fixtures].sort(compareFixturesCanonical);
}

export function sortFixtureIdsCanonical(fixtureIds = [], fixtures = []) {
  const fixturesById = new Map(
    fixtures.map((fixture) => [Number(fixture?.id ?? fixture?.fixture_id), fixture]),
  );

  return [...new Set(fixtureIds.map(Number).filter(Number.isFinite))]
    .map((id) => fixturesById.get(id) ?? { id })
    .sort(compareFixturesCanonical)
    .map((fixture) => Number(fixture?.id ?? fixture?.fixture_id));
}
